import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StorefrontAPI from 'utilities/storefrontApi';

/**
 * Resolve the brand for the current storefront page.
 *
 * Two paths:
 *   - `/site/:brandRef/...` — brandRef in the URL.
 *   - Custom domain         — backend resolves brand from Host header.
 *
 * Returns `{ brand, error }`. Both are null while loading.
 */
export default function useBrandFromParams() {
  const { brandRef } = useParams();
  const [brand, setBrand] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    StorefrontAPI.getStorefrontInfo(brandRef)
      .then(setBrand)
      .catch((e) => setError(e?.message || 'Brand not found'));
  }, [brandRef]);

  return { brand, error };
}
